import { Button, Form } from 'antd'
import { StoreValue } from 'antd/es/form/interface'
import { FC } from 'react'
import { PlusOutlined } from '@ant-design/icons'

interface MaterialAddProps {
    add: (defaultValue?: StoreValue, insertIndex?: number) => void
}

const MaterialAdd: FC<MaterialAddProps> = ({ add }) => {
    return (
        <Form.Item label={' '} style={{ marginBottom: 0 }}>
            <Button
                type={'primary'}
                icon={<PlusOutlined />}
                onClick={() => {
                    add({})
                }}
                // onClick={() => {
                //     const fullName = _.concat(
                //         listNamePath,
                //         configurationsName
                //     )
                //     const values = form.getFieldValue(fullName) || []
                //     form.setFieldValue(fullName, [...values, {}])
                // }}
            >
                Добавить ширину
            </Button>
        </Form.Item>
    )
}

export default MaterialAdd
